module.exports = __webpack_public_path__ + "public/images/notification-list-bg.dfba6b479887ae624b609ff7faedc6db.png";